import React, { forwardRef } from "react";
import PropTypes from "prop-types";

const Header = forwardRef(({ children }, ref) => {
  return <span ref={ref}>{children}</span>;
});

Header.displayName = "LinkGroup.Header";

Header.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export default Header;
